import {
  laptopLargeMax,
  largeTabletMax,
  largeTabletMin,
  mobileXXLargeMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

const GridContainer = styled.ul<{ maxColumns: number; popularProperties?: boolean }>`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.maxColumns}, minmax(0, 1fr))`};
  grid-column-gap: 20px;
  grid-row-gap: 30px;
  grid-auto-flow: row dense;
  list-style: none;
  padding: 0 20px;

  @media (${laptopLargeMax}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (${laptopLargeMax}) and (${largeTabletMin}) {
    /* on homepage hides 4th property */
    ${({ popularProperties }) =>
      popularProperties
        ? `
      & li:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
        display: none;
      }
    `
        : ''}
  }

  @media (${largeTabletMax}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 15px;
  }

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    padding: 15px;
  }
`;

export const UpperAdContainer = styled.li`
  grid-column: 1 / span 3;
  grid-row-start: 2;

  @media (${largeTabletMax}) {
    grid-column: 1 / span 2;
    grid-row-start: 3;
  }

  @media (${mobileXXLargeMax}) {
    grid-column: 1 / span 1;
    grid-row-start: 5;
  }
`;

export const LowerAdContainer = styled.li`
  grid-column: 1 / span 3;
  grid-row-start: 5;

  @media (${largeTabletMax}) {
    grid-column: 1 / span 2;
    grid-row-start: 6;
  }

  @media (${mobileXXLargeMax}) {
    grid-column: 1 / span 1;
    grid-row-start: 10;
  }
`;

export const FooterContainer = styled.li`
  grid-column: 1 / span 3;

  @media (${largeTabletMax}) {
    grid-column: 1 / span 2;
  }

  @media (${mobileXXLargeMax}) {
    grid-column: 1 / span 1;
  }
`;

export default GridContainer;
